import React, { createContext, useContext, useState, ReactNode } from 'react';

/**
 * LoadingBarContext Interface
 * @author Lian
 */
interface LoadingBarContextInterface {
  /**
   * 로딩 상태를 true로 변경
   */
  showLoading: () => void;
  /**
   * 로딩 상태를 false로 변경
   */
  hideLoading: () => void;
  /**
   * 현재 로딩 상태
   */
  isLoading: boolean;
}

const LoadingBarContext = createContext<LoadingBarContextInterface | undefined>(undefined);

/**
 * LoadingBarProvider 컴포넌트 생성
 * @author Lian
 */
export const LoadingBarProvider = ({ children }: { children: ReactNode }) => {
  const [isLoading, setIsLoading] = useState(false);

  const showLoading = () => setIsLoading(true);
  const hideLoading = () => setIsLoading(false);

  return (
    <LoadingBarContext.Provider value={{ isLoading, showLoading, hideLoading }}>
      {children}
    </LoadingBarContext.Provider>
  );
};

export const useLoading = (): LoadingBarContextInterface => {
  const context = useContext(LoadingBarContext);
  if (!context) {
    throw new Error('useLoading must be used within a LoadingProvider');
  }
  return context;
};
